<template>
	<div>
		<div class="tag-sections">
			<section class="tag">
				<h2 class="has-sub">
					Möchtest du Homeoffice / Remote Work?
					<span class="sub">Details findest Du später bei den Jobs.</span>
				</h2>
				<HomeOffice
					v-model="homeOffice"
					@input="emitChangeEvent"
				/>
			</section>
			<section class="tag">
				<h2>{{ title }}</h2>
				<Geo
					v-model="geo"
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import {mapState} from "vuex";
import {isDefined} from "@/helper/Value";
import Geo from "@/vue/application/Geo";
import HomeOffice from "@/vue/application/HomeOffice";
import {arrayIsNotEmpty} from "@/helper/Array";

export default {

	components: {
		HomeOffice,
		Geo,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			geo: this.value?.geo,
			homeOffice: this.value?.homeOffice || {yesNo: null},
		};
	},

	computed: {
		...mapState('meta', [
			'meta',
		]),
		geoValid ()
		{
			return isDefined(this.geo) && arrayIsNotEmpty(this.geo);
		},
		homeOfficeValid ()
		{
			return isDefined(this.homeOffice);
		},
		valid ()
		{
			return this.geoValid
				&& this.homeOfficeValid;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', {
				geo: this.geo,
				homeOffice: this.homeOffice,
				valid: this.valid,
			});
		}
	}
}
</script>
